// Used for any user information updating
//  which currently includes "instructor"/ "partner" profile

// - account settings
// - instructor profile
import moment from 'moment-timezone'
import {firebase} from 'util/auth';
import { snapshotToObjects } from 'util/firestore';
import { cancelReservation } from 'util/api/CheckoutAPI'
import {apiRequest} from 'util/api/util'
import {
    SET_USER, 
    SET_USER_SAVING, 
    SET_USER_ERROR, 
    SET_USER_SAVE_SUCCESS, 
    SET_USER_LOADING,
    SET_USER_RESERVATIONS,
    CANCEL_USER_RESERVATION,
    SET_USER_PURCHASES,
    RESET_USER,
    ADD_USER_RESERVATION
} from 'store/reducers/userReducer'

export const loadUserInformation = () => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

    };
}

export const resetUser = (user) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        dispatch({ type: RESET_USER})
    }
}

function saveProfilePhoto(file, userId) {
    console.log('saveProfilePhoto')

    const storage = firebase.storage();
    return new Promise(async (resolve, reject) => {
        var ref = storage.ref();
        ref = ref.child(`users/${userId}/${Date.now()}-${"profileimage"}`)
        try {
            const snapshot = await ref.put(file)
            const url = await snapshot.ref.getDownloadURL()
            resolve(url)
        } catch (err) {
            reject(err)
        }
    })
}

function savePartnerPhoto(file, userId) {
    console.log('savePartnerPhoto')

    const storage = firebase.storage();
    return new Promise(async (resolve, reject) => {
        var ref = storage.ref();
        ref = ref.child(`users/${userId}/${Date.now()}-${"partnerimage"}`)
        try {
            const snapshot = await ref.put(file)
            const url = await snapshot.ref.getDownloadURL()
            resolve(url)
        } catch (err) {
            reject(err)
        }
    })
}

function savePartnerLogo(file, userId) {
    console.log('savePartnerLogo')

    const storage = firebase.storage();
    return new Promise(async (resolve, reject) => {
        var ref = storage.ref();
        ref = ref.child(`users/${userId}/${Date.now()}-${"partnerLogo"}`)
        try {
            const snapshot = await ref.put(file)
            const url = await snapshot.ref.getDownloadURL()
            resolve(url)
        } catch (err) {
            reject(err)
        }
    })
}

/// Copied over to instructor
export const updateAccountInfo = (data) => {
    return async (dispatch, getState, { getFirebase, getFirestore }) => {

        const state = getState();
        const userId = state.user.userData.platformID;

        dispatch({type: SET_USER_SAVING, saving: true})

        if (data.avatarImage) {
            try {
                const url = await saveProfilePhoto(data.avatarImage, userId)
                data.profileImageUrl = url
            } catch (err) {
                dispatch({type: SET_USER_SAVING, saving: false})
                dispatch({type: SET_USER_ERROR, error: "Oops! There was an issue saving this image, please try again."})
                return
            }
        }

        if (data.partnerImage) {
            try {
                const url = await savePartnerPhoto(data.partnerImage, userId)
                data[`instructorProfile.partnerImageUrl`] = url
            } catch (err) {
                dispatch({type: SET_USER_SAVING, saving: false})
                dispatch({type: SET_USER_ERROR, error: "Oops! There was an issue saving this image, please try again."})
                return
            }    
        }

        if (data.partnerLogo) {
            try {
                const url = await savePartnerLogo(data.partnerLogo, userId)
                data[`instructorProfile.partnerLogoUrl`] = url
            } catch (err) {
                dispatch({type: SET_USER_SAVING, saving: false})
                dispatch({type: SET_USER_ERROR, error: "Oops! There was an issue saving this image, please try again."})
                return
            }   
        }
        // data.instructorProfile.partnerName = data[`instructorProfile.partnerName`]

        delete data.avatarImage;
        delete data.partnerImage;
        delete data.partnerLogo;

        const firestore = getFirestore();

        if (data.widgetName) {
            data.widgetName = data.widgetName.toLowerCase().replace(/[^!a-zA-Z0-9-_]/g, '');
            const snapshot = await firestore.collection('users').where('widgetName', "==", data.widgetName).get()
            if (!snapshot.empty && snapshot.docs[0].id !== userId) {
                dispatch({type: SET_USER_SAVING, saving: false})
                dispatch({type: SET_USER_ERROR, error: `The scheduling URL "${data.widgetName}" is already taken, please choose a new one 😊` })
                return
            }
        }

        return firestore.collection('users').doc(userId)
            .update(data)
            .then(() => {
                const updated_user = {...state.user.userData, ...data}
                dispatch({type: SET_USER, userData: updated_user})
                dispatch({type: SET_USER_SAVING, saving: false})
                dispatch({type: SET_USER_ERROR, error: null})
                dispatch({type: SET_USER_SAVE_SUCCESS, success: "Congrats! Your information has been updated! 😊"})
                setTimeout(() => {
                    dispatch({type: SET_USER_SAVE_SUCCESS, success: null})
                }, 5000)
            })
            .catch( err => {
                dispatch({type: SET_USER_SAVING, saving: false})
                dispatch({type: SET_USER_ERROR, error: "Oops! There was an issue saving. Please try again."})
            })

    };
}

// export const loadAuthorizedUser = (user) => {
//     return (dispatch, getState, { getFirebase, getFirestore }) => {
//         // make async call to DB
//         const firestore = getFirestore();
//         dispatch({type: SET_USER_LOADING, loading: true})
//         return firestore.collection("users").where("authID", "==", user.uid)
//             .get()
//             .then(snapshot => {
//                 const users = snapshotToObjects(snapshot)
//                 dispatch({type: SET_USER_LOADING, loading: false})
//                 if (users.length > 0) {
//                     const user = users[0];
//                     dispatch({type: SET_USER, userData: user})
//                     return user
//                 }
//             })
//             .catch( err => {
//                 dispatch({type: SET_USER_LOADING, loading: false})
//                 console.log("error fetching user data: " + err)
//             });
//     }
// };

export const loadReservations = (user) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        if (!user || !user.id) {
            return
        }
        const firestore = getFirestore();
        dispatch({type: SET_USER_LOADING, loading: true})
        return firestore.collection("reservations").where("userID", "==", user.id)
            .get()
            .then(snapshot => {
                const NOW = moment().unix()
                const reservations = snapshotToObjects(snapshot)
                                    .filter(val => { 
                                        // Reservations can expire for on demand videos
                                        if (val.expires && val.expires < NOW) {
                                            // console.log("FOUND EXPIRING VIDEO")
                                            return false
                                        }
                                        return val.deleted !== false
                                    })
                dispatch({type: SET_USER_RESERVATIONS, reservations: reservations})
                dispatch({type: SET_USER_LOADING, loading: false})
            })
            .catch(err => {
                dispatch({type: SET_USER_LOADING, loading: false})
                return {error: err}
            })
    }
}

export const insertReservation = (reservation) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        dispatch({type: ADD_USER_RESERVATION, reservation: reservation})
    }
}

export const loadPurchases = (user) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        if (!user || !user.id) {
            return
        }
        dispatch({type: SET_USER_LOADING, loading: true})
        return apiRequest("app/purchases")
            .then(purchases => {
                dispatch({type: SET_USER_PURCHASES, purchases: purchases})
                dispatch({type: SET_USER_LOADING, loading: false})
            })
            .catch(err => {
                dispatch({type: SET_USER_LOADING, loading: false})
                return {error: err}
            })
    }
}

export const cancelUserReservation = (reservationId) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        dispatch({type: SET_USER_LOADING, loading: true})
        
        console.log("cancelling")
        return cancelReservation(reservationId)
            .then(response => {
                dispatch({type: SET_USER_LOADING, loading: false})
                dispatch({type: CANCEL_USER_RESERVATION, id: reservationId})
                return response
                if (response.success) {
                    
                } else {
                    throw Error(response)
                }
                // console.log("Response from cancelling")
                // console.log(response)
                // dispatch({type: SET_USER_LOADING, loading: false})
                // dispatch({type: CANCEL_USER_RESERVATION, id: reservationId})
                // console.log(`Just cancled? ${JSON.stringify(response)}`)
                // return response
            })
            .catch(err => {
                console.log("error cancelling")
                console.log(err)
                dispatch({type: SET_USER_LOADING, loading: false})
                return err
            })
    }
}
